import { DeepAgent, Message } from '../types/deep-agent.dictionary'

export type BuildMode = 'agent' | 'workflow'

export type DeepAgentState = {
  isStreaming: boolean
  messages: Message[]
  pendingAiResponse: boolean
  streamingAiResponse: boolean
  thread_id: string | null
  pendingRequestActionMessage: string | null
  previousUserMessage: string | null
  agentId: string | null
  models: any[]
  selectedModel: string | null
  currentAgent: DeepAgent | null
  savingAgent: boolean
  saveError: string | null
  buildMode: BuildMode
}

export const initialState: DeepAgentState = {
  isStreaming: false,
  messages: [],
  pendingAiResponse: false,
  streamingAiResponse: false,
  thread_id: null,
  pendingRequestActionMessage: null,
  previousUserMessage: null,
  agentId: null,
  models: [],
  selectedModel: null,
  currentAgent: null,
  savingAgent: false,
  saveError: null,
  buildMode: 'agent',
}
